export type ResultType = "Success" | "Error" | "ValidateFailed" | "AuthenticationRequired" | "AccessDenied";

export interface IResult<T> {
    data?: T;
    errorCode: number;
    errors: string[];
    isSuccess: boolean;
    message?: string;
    type: ResultType;
}

export class Result<T> implements IResult<T> {

    /**
     * Returns a string array of errors or the result message
     * @param r The result object
     */
    public static errorsOrMessage(r: IResult<any>): string[] {
        return r.errors && r.errors.length
            ? r.errors
            : (r.message ? [r.message] : []);
    }

    /**
     * Returns true if the given result was failed due to a connection error
     * @param r The result object
     */
    public static isConnectionFail(r: IResult<any>): boolean {
        return r.type === "Error" && (r.message || "").toLowerCase().indexOf("failed to fetch") > -1;
    }

    public data?: T;
    public errorCode: number = 0;
    public errors: string[] = [];
    public isSuccess = false;
    public message?: string;
    public type: ResultType = "Error";

    public constructor(data?: T, type?: ResultType) {
        this.data = data;
        this.type = type || "Success";
        this.isSuccess = this.type === "Success";
    }
}



// WEBPACK FOOTER //
// ./src/models/result/Result.ts